import { MenuHelper, IMenuDefinition, menuType } from "@/helpers/MenuHelper";
import vuestore from '@/store';
import { VersioneExSituStore } from './store/VersioneExSitu.store';
import { securityService } from '@/services/securityService';
import { layoutHelper } from '@/helpers/LayoutHelper';

export function init() {
  const userRoles  = securityService.getInfo()?.roles;

  if (layoutHelper.isWeb && userRoles.includes("Amministratore")){
    MenuHelper.addMenuDefinition(
      { name: "VersioneExSitu", description: "Versioni ex situ", icon: "icon-uf_exsitu", routeName: "VersioneExSitu", orderIndex: 102, group: "Impostazioni" } as IMenuDefinition,
      { section: menuType.drawer },
    );
  }

  //REGISTRAZIONE DELLO STORE
  vuestore.registerModule(VersioneExSituStore.PREFIX, VersioneExSituStore);
}
